function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "#EEF4FF",
  d: "M0 22.875h131.25v123.958H0z"
}), React.createElement("path", {
  stroke: "#621FFF",
  strokeWidth: 1.5,
  d: "M30.625 1h138.542v11.667H30.625zM30.625 49.125h125.417v11.667H30.625zM30.625 24.333H175V36H30.625zM30.625 73.917h125.417v11.667H30.625zM30.625 98.708h88.958v11.667H30.625z"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 176,
    height: 147,
    viewBox: "0 0 176 147"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/text_icon.a35b3a8b.svg";
export { SvgComponent as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ./node_modules/svgr/webpack.js!./src/containers/defineNeed/text_icon.svg
// module id = 452
// module chunks = 0